import i18n from './../../../shared/i18n';
import BaseModel from "../../../core/components/input-widget/BaseModel";
import {store} from "@/plugins/vuex";
import cloneDeep from "lodash/cloneDeep";

export default class RelationModel extends BaseModel {
  uuid = null;
  object_uuid = null;
  type = null;
  intermediary_commission_rate = null;
  confirmations = null;
  suggestions = null;
  settlements = null;
  cc = null;
  related_customer_uuid = null;
  related_customer = null;
  reference_number = null;
  hide_from_communication = null;
  including_vat = false;
  note = null;
  agreement_type = null;

  constructor(data = {}) {
    super();
    // if (store && store.state && store.state.global.inclusiveTiersEnabled) {
    //   if (data.intermediary_commission_rate) {
    //     data.intermediary_commission_rate = Math.round(parseFloat(data.intermediary_commission_rate * (store.state.global.currentBranch.tax_rate / 100 + 1)))
    //     console.log(data.intermediary_commission_rate);
    //   }
    // }
    Object.assign(this, {...data});
  }

  rules = {
    related_customer_uuid: 'required',
  };

  attributeLabels = {
    related_customer_uuid: i18n.t('Customer'),
    confirmations: i18n.t('Confirmations'),
    suggestions: i18n.t('Suggestions'),
    settlements: i18n.t('Settlements'),
    hide_from_communication: i18n.t('Hide From Communications'),
    intermediary_commission_rate: i18n.t('Intermediary Commission Rate'),
    reference_number: i18n.t('Reference Number'),
    including_vat: i18n.t('Including Vat'),
    taxable: i18n.t('Taxable'),
    note: i18n.t('Note'),
    agreement_type: i18n.t('Agreement Type'),
    cc: i18n.t('Remove from CC'),
  };


  toJSON() {
    return cloneDeep(super.toJSON())
    // if (store && store.state && store.state.global.inclusiveTiersEnabled) {
    //   if (data.intermediary_commission_rate) {
    //     data.intermediary_commission_rate = parseFloat(data.intermediary_commission_rate / (store.state.global.currentBranch.tax_rate / 100 + 1)).toFixed(2)
    //   }
    // }
  }
}
